'use es6';

import BaseContainer from './BaseContainer';
const ScopesContainer = BaseContainer.create();
export default ScopesContainer;